import request from '@/utils/request';

// 登录
export function login(data) {
  return request({
    url: '/v1/qws/login',
    method: 'post',
    data: data
  });
}
// 获取用户信息
export function getUserInfo(userId) {
  return request({
    url: `/v1/qws/get/${userId}/user-info`,
    method: 'get'
  });
}

/**
 *   刷新token
 * @method refreshToken
 * @return { request } axsio请求封装
 */
// export function refreshToken(refreshToken) {
//   return request({
//     url: `/op/user/refresh`,
//     method: 'get',
//     params: {
//       refreshToken
//     }
//   });
// }
